import { formatUnits } from 'viem';

import { isTriggerOrderEligibleToken } from '@/components/TriggerOrders/utils';

import type { Transaction } from '@/store/transaction/types';

const ELIGIBLE_TRANSACTION_TYPES: ReadonlySet<Transaction['transactionType']> = new Set([
  'swap',
  'batch-swap',
  'solana-swap',
  'gasless',
  'intents',
  'cross-chain',
]);

/** Shape-level eligibility; the sell amount itself resolves via `usePostSwapSellAmount`. */
export function isPostSwapTriggerOrderEligible(transaction: Transaction): boolean {
  const { buyToken } = transaction;

  return (
    ELIGIBLE_TRANSACTION_TYPES.has(transaction.transactionType) &&
    isTriggerOrderEligibleToken(buyToken.address, buyToken.chainId)
  );
}

/** The exact realized buy amount already persisted on the transaction, if any. */
export function getPostSwapSellAmount(transaction: Transaction): string {
  if (transaction.parsedTx?.tokenOut.amount) return transaction.parsedTx.tokenOut.amount;
  if (
    transaction.transactionType === 'intents' &&
    transaction.raw &&
    'settledBuyAmount' in transaction.raw &&
    transaction.raw.settledBuyAmount
  ) {
    return formatUnits(BigInt(transaction.raw.settledBuyAmount), transaction.buyToken.decimals);
  }
  return '';
}
